module.exports = __webpack_public_path__ + "img/折叠.8411332a.png";